import React from 'react'
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'

export default function SelectLevel({ catId, setCatId, disabled, showAdmin }) {
    return (
        <FormControl fullWidth>
            <InputLabel id="day-label">Select Level (Grade)*</InputLabel>
            <Select
                labelId="day-label"
                id="designation"
                value={catId}
                label="Select Level (Grade)*"
                onChange={(e) => setCatId(e.target.value)}
                required
                disabled={disabled}
            >


                <MenuItem key="2" value="2">AS Level</MenuItem>
                <MenuItem key="3" value="3">IGCSE 02</MenuItem>
                <MenuItem key="4" value="4">IGCSE 01</MenuItem>
                <MenuItem key="5" value="5">Foundation Year 9</MenuItem>
                <MenuItem key="6" value="6">Foundation Year 8</MenuItem>
                <MenuItem key="7" value="7">Foundation Year 7</MenuItem>
                {showAdmin === 1 && <MenuItem key="16" value="16">Registration Fees</MenuItem>}

            </Select>
        </FormControl>
    )
}
